







































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ConfirmButton from '@/components/ConfirmButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import Dialog from '@/components/Dialog.vue';
import ExplorerService from '@/services/explorer.service';
import DataSetService from '@/services/dataset.service';
import {DataSet, DataSetMetadata, ExplorerConfiguration, ExplorerView, IDataTableHeader} from '@/types';
import {Getter} from 'vuex-class';
import FieldSelectionCard from '@/components/dataexplorer/FieldSelectionCard.vue';
import GenericButton from '@/components/GenericButton.vue';

@Component({
  components: {GenericButton, FieldSelectionCard, Dialog, CancelButton, ConfirmButton},
})
export default class CreateViewConfigurationDialog extends Vue {
  @Getter private hasPermission: any;
  @Getter private activeOrganisation: any;
  @Getter private login: any;

  private loading: boolean = false;
  private datasets: DataSet[] = [];

  private dataset: DataSet | null = null;
  private metadataPromise: Promise<DataSetMetadata> | null = null;
  private selectedFields: Record<string, string> = {};
  private page: number = 0;
  private errorMsg: string = '';
  private selectedDataset: DataSet | null =  null;
  private viewName: string = '';
  private fields: Record<string, Record<string, Record<string, string>>> = {};

  private get disableNext(): boolean {
    return (!this.selectedDataset || !this.viewName);
  }

  public async mounted() {
    try {
      this.loading = true;
      this.datasets = await this.getDataSets();
    } finally {
      this.loading = false;
    }
  }

  private async getDataSets(): Promise<DataSet[]> {
    const datasets = await DataSetService.getDataSets();
    datasets.sort((a, b) => a.name.localeCompare(b.name));
    return datasets.filter((d: DataSet) => d.query === true);
  }

  private async createView() {
    if (this.dataset && this.dataset.uuid) {
      try {
        const viewToAdd: ExplorerView = {
          name: this.viewName,
          dataset_uuid: this.dataset.uuid!,
          dataset_name: this.dataset.name,
          organisation_id: this.activeOrganisation[0].id,
          configuration: {
            filters: {},
            layout: {
              headers: Object.entries(this.fields.displayFields).map(([key, value]) => ({
                text: value.text,
                id: value.id,
                value: key,
                isCustomField: true,
              })),
              removedHeaders: [],
            },
          },
          owner_id: this.login.details.id,
          is_public: false,
        };

        const defaultHeaders = await this.getDefaultHeaders();
        viewToAdd.configuration.layout.headers.unshift(...defaultHeaders);

        const newView = await ExplorerService.addExplorerViewConfiguration(viewToAdd);

        this.$emit('update:viewCreated', newView);
        this.$emit('close:dialog');
        this.page = 0;
        this.errorMsg = '';

        this.viewName = '';
        this.selectedDataset = null;
      } catch (e: any) {
        this.page = 0;
        this.errorMsg = e.message;
      }
    }
  }

  private setDataset(dataset: DataSet) {
    this.dataset = dataset;
    this.metadataPromise = DataSetService.getDatasetMetadata(this.dataset!.uuid!);
  }

  private async getDefaultHeaders(): Promise<IDataTableHeader[]> {
      if (!this.dataset || !this.dataset.uuid) {
        throw new Error('Dataset is not selected');
      }

      const metadata = await this.metadataPromise;
      if (!metadata || !Array.isArray(Object.keys(metadata.tags))) {
        throw new Error('Metadata is not loaded for this dataset');
      }

      const defaultHeaders: any = Object.keys(metadata.tags).map((t: string) => {
        return { text: this.getTagColumnNames(t), value: t };
      });

      if (metadata.interfaces) {
        defaultHeaders.push({ text: 'Interface', value: 'interface' });
      } else {
        defaultHeaders.push({ text: 'Device Type', value: 'deviceType' });
        defaultHeaders.push({ text: 'Event Type', value: 'eventType' });
      }
      defaultHeaders.unshift({ text: 'Time', value: 'time' });
      return defaultHeaders;
  }

  private getTagColumnNames(tag: string) {
    const tagNames: {[key: string]: string} = {
      time: 'Time',
      deviceId: 'Device ID',
      siteId: 'Site ID',
      site: 'Site',
      locationId: 'Location ID',
      location: 'Location',
      projectId: 'Project ID',
      channelId: 'Channel ID',
    };
    return tagNames[tag];
  }

  private async stepForward() {
    ++this.page;
  }

  private stepBack() {
    --this.page;
  }

  private closeDialog() {
    this.page = 0;
    this.$emit('close:dialog');
  }

  private errorCaptured(e: any) {
    this.page = 0;
    this.errorMsg = e.message;
    return false;
  }
}
